module.exports = __webpack_public_path__ + "img/ml3023.df41ee9d.png";